export const getFormFieldName = (
  name: string[],
  isVariant = false,
  index = 0,
): string[] => (isVariant ? [`${index}-variant`, ...name] : name)
